var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "div",
                { staticClass: "container" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: "",
                        size: "small",
                        "label-width": "90px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "订单编号" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth ",
                              attrs: {
                                placeholder: "请输入",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.orderNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "orderNo", $$v)
                                },
                                expression: "listPram.orderNo",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: { click: _vm.handerSearch },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商家单号" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth ",
                              attrs: {
                                placeholder: "请输入",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.outOrderNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "outOrderNo", $$v)
                                },
                                expression: "listPram.outOrderNo",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: { click: _vm.handerSearch },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "订单状态" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth ",
                              attrs: { clearable: "", placeholder: "请选择" },
                              on: { change: _vm.handerSearch },
                              model: {
                                value: _vm.listPram.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "status", $$v)
                                },
                                expression: "listPram.status",
                              },
                            },
                            _vm._l(_vm.orderStateOption, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "下单小程序" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                placeholder: "请输入选择",
                                clearable: "",
                              },
                              on: { change: _vm.handerSearch },
                              model: {
                                value: _vm.listPram.customerId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "customerId", $$v)
                                },
                                expression: "listPram.customerId",
                              },
                            },
                            _vm._l(_vm.customers, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "用户手机" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth ",
                              attrs: {
                                placeholder: "请输入",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.phone,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "phone", $$v)
                                },
                                expression: "listPram.phone",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: { click: _vm.handerSearch },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "交易时间" } },
                        [
                          _c("el-date-picker", {
                            staticClass: "selWidth ",
                            attrs: {
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              type: "datetimerange",
                              "range-separator": "-",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期",
                            },
                            on: { change: _vm.handerSearch },
                            model: {
                              value: _vm.listPram.dataRenage,
                              callback: function ($$v) {
                                _vm.$set(_vm.listPram, "dataRenage", $$v)
                              },
                              expression: "listPram.dataRenage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "mr20",
                      attrs: { type: "primary" },
                      on: { click: _vm.exportList },
                    },
                    [_vm._v("结果导出")]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.listData.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", "min-width": "50" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderNo",
                  label: "订单编号",
                  "min-width": "190",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "outOrderNo",
                  label: "商家单号",
                  "min-width": "190",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "productName",
                  label: "商品名称",
                  "min-width": "260",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "myStatus",
                  label: "订单状态",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "tstatus",
                  label: "三方状态",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "price", label: "订单金额", "min-width": "140" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "customerPrice",
                  label: "客户扣款",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "supplyPrice",
                  label: "供应商扣款",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "下单时间",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "updateTime",
                  label: "更新时间",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "username",
                  label: "下单用户",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "customer",
                  label: "下单小程序",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "80",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openOrderDetail(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("详情")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.listPram.page,
              "page-sizes": _vm.constants.page.limit,
              layout: _vm.constants.page.layout,
              total: _vm.listData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("OrderDetail", {
        ref: "OrderDetailRef",
        on: { doRefresh: _vm.handerSearch },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }